import React, { Component } from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'

import SharedForm from '../../shared/SharedForm'
import OrganizationSearchSelect from '../../shared/OrganizationSearchSelect'
import PhoneNumberValidator from '../../validators/PhoneNumberValidator'
import PresenceValidator from '../../validators/PresenceValidator'
import PhoneInput from '../../shared/PhoneInput'
import Input from '../../shared/inputs/Input'
import DateUtils from '@date-io/date-fns'
import {
  DatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers'
import Checkbox from '../../shared/inputs/Checkbox'

import TitleFromIdNumber from '../../input_formatting/title_from_id_number'

export default class ClientForm extends Component {
  static propTypes = {
    client: PropTypes.object,
    tenant: PropTypes.string.isRequired,
    identification_types: PropTypes.array.isRequired,
    paraplannerWealthManagers: PropTypes.array,
    organizations: PropTypes.array,
    cohortsByOrg: PropTypes.object,
    canInvite: PropTypes.bool
  }

  static defaultProps = {
    client: {}
  }

  constructor(props) {
    super(props)

    this.IDENTIFICATION_TYPES = {}
    this.props.identification_types.map((data) => {
      this.IDENTIFICATION_TYPES = { ...this.IDENTIFICATION_TYPES, [data[0]]: data[1] }
    })

    this.state = {
      client: {
        identification_type: this.IDENTIFICATION_TYPES["SA ID Number"]
      },
      sendInvitation: false,
      selectedOrgId: null,
      selectedCohort: null,
      fieldsValidity: {
        firstName: false,
        lastName: false,
        email: false,
        preferredName: true,
        cellphoneNumber: false,
        identificationType: true,
        identificationNumber: false,
        entityId: true,
        wealthManagerId: this.props.paraplannerWealthManagers ? false : true,
        organizationId: this.props.organizations ? false : true,
      },
      formValid: false
    }

    this.titleFromIdNumber = new TitleFromIdNumber()
  }

  componentDidMount = () => {
    this.setState({
      client: this.props.client
    })
  }

  componentWillReceiveProps = (newProps) => {
    this.setState({
      client: newProps.client
    })
  }

  onChange = (field, value) => {
    let client = this.state.client
    client[field] = value

    this.validateForm()

    this.setState({
      client: client
    })
  }

  onCheckboxChange = (value) => {
    this.setState({
      sendInvitation: value
    })
  }

  // When the coach selects an organisation, pre-select that org's most recent
  // cohort (options are ordered oldest-first, so the last is the newest).
  onOrgChange = (option) => {
    if (!option) {
      this.setFieldValidity("organizationId", this.props.organizations ? false : true)
      this.setState({
        selectedOrgId: null,
        selectedCohort: null
      })
      return
    }

    this.setFieldValidity("organizationId", true)

    const cohorts = (this.props.cohortsByOrg && this.props.cohortsByOrg[option.id]) || []
    this.setState({
      selectedOrgId: option.id,
      selectedCohort: cohorts.length ? cohorts[cohorts.length - 1] : null
    })
  }

  onCohortChange = (option) => {
    this.setState({ selectedCohort: option || null })
  }

  setFieldValidity = (field, isValid) => {
    let newFieldValidity = this.state.fieldsValidity
    newFieldValidity[field] = isValid

    this.setState({
      fieldsValidity: newFieldValidity
    }, this.validateForm())
  }

  validateForm = () => {
    const fieldsValidity = this.state.fieldsValidity
    const formValid = !Object.keys(fieldsValidity).map(key => fieldsValidity[key]).includes(false)

    this.setState({
      formValid: formValid
    })
  }

  onIdentificationTypeChange = (value) => {
    this.setFieldValidity('identificationNumber', false)
    this.setFieldValidity('identificationType', true)
    this.onChange('identification_number', '')
    this.onChange('identification_type', value)
  }

  saveHandler = (event) => {
    if (window.gtag) {
      window.gtag('event', 'new_client_created', {
        'event_category': 'UserManagement'
      })
    }
    return true
  }

  setPostUrl = () => {
    if (this.props.isProspect) {
      return `/prospects`
    } else {
      return `/clients`
    }
  }

  render() {
    return (
      <SharedForm actionUrl={this.setPostUrl()} methodType="POST" authenticityToken={this.props.token}>
        <fieldset className='form__input client_edit'>
          <div className='form-group'>
            <Input inputType="select" id="client_title_select_input" name="client[title]"
              isHalf={true} label="Title" value={this.state.client.identification_type === this.IDENTIFICATION_TYPES["SA ID Number"] ? this.titleFromIdNumber.determineTitle(this.props.client.identification_number, "mr", "ms") : ""} onChange={(value) => this.onChange('title', value)}>
              <option hidden></option>
              <option value="mrs">Mrs</option>
              <option value="miss">Miss</option>
              <option value="mr">Mr</option>
              <option value="ms">Ms</option>
              <option value="dr">Dr</option>
              <option value="prof">Prof</option>
              <option value="adm">Adm</option>
              <option value="adv">Adv</option>
              <option value="bishop">Bishop</option>
              <option value="brig">Brig</option>
              <option value="brig_ge">Brig Ge</option>
              <option value="capt">Capt</option>
              <option value="cmdt">Cmdt</option>
              <option value="col">Col</option>
              <option value="gen_maj">Gen Maj</option>
              <option value="genl">Genl</option>
              <option value="judge">Judge</option>
              <option value="lt_col">Lt Col</option>
              <option value="lt_gen">Lt Gen</option>
              <option value="maj">Maj</option>
              <option value="past">Past</option>
              <option value="rabbi">Rabbi</option>
              <option value="rev">Rev</option>
              <option value="ser">Ser</option>
              <option value="sir">Sir</option>
              <option value="supt">Supt</option>
              <option value="the_hon">The Hon</option>
            </Input>
            <Input name="client[first_names]" id="client_first_name_input" onChange={(value) => this.onChange('first_names', value)}
              label="First names" isHalf={true} value={this.props.client.first_names} isRequired={true}
              isValidCallback={(isValid) => this.setFieldValidity("firstName", isValid)} validations={['presence']}></Input>
          </div>
          <div className='form-group'>
            <Input name="client[last_name]" id="client_last_name_input" onChange={(value) => this.onChange('last_name', value)}
              label="Surname" isHalf={true} value={this.props.client.last_name}
              isValidCallback={(isValid) => this.setFieldValidity("lastName", isValid)} validations={['presence']}></Input>

            <Input name="client[preferred_name]" id="client_preferred_name_input" value={this.props.client.preferred_name}
              label="Preferred name"
              isHalf={true} onChange={(value) => this.onChange('preferred_name', value)}></Input>
          </div>
          <div className='form-group'>
            <Input name="client[email]" id="client_email_input" label="email" validations={['email']}
              isValidCallback={(isValid) => this.setFieldValidity("email", isValid)}
              isHalf={true} value={this.props.client.email} onChange={(value) => this.onChange('email', value)}></Input>

            <PhoneInput label="Cellphone number"
              placeholder="Enter cellphone number"
              name="client[cellphone_number]"
              value={this.state.home_number}
              className="form-input--large form-input--has-padding is-half"
              validator={(val) => {
                let isValid = PresenceValidator.isValid(val) && PhoneNumberValidator.isValid(val)
                this.setFieldValidity("cellphoneNumber", isValid)

                if (!isValid) {
                  return "Cellphone number is invalid"
                }
              }}
              handleChange={this.handleChange} />
          </div>
          <div className='form-group'>
            <Input inputType="select" id="client_identification_type_select_input" name="client[identification_type]"
              isValidCallback={(isValid) => this.setFieldValidity("identificationType", isValid)} isHalf={true} validations={['identification_type']} formState={this.state.client}
              label="Identification Type" value={this.state.client.identification_type} onChange={this.onIdentificationTypeChange}>
              <option hidden></option>
              {this.props.identification_types.map((id_type, idx) => <option key={`id-type-${idx}`} value={id_type[1]}>{id_type[0]}</option>)}
            </Input>
            <Input name="client[identification_number]" id="client_id_number_input" value={this.props.client.identification_number} validations={this.state.client.identification_type === this.IDENTIFICATION_TYPES["Passport"] ? ['passport'] : ['idnumber']}
              isValidCallback={(isValid) => this.setFieldValidity("identificationNumber", isValid)}
              label="Identification Number" isHalf={true} onChange={(value) => this.onChange('identification_number', value)}></Input>
          </div>
          <div className="form-group">
            {this.props.tenant == "gci" &&
              <Input name="client[entity_id]" id="client_entity_id_input" onChange={(value) => this.onChange('entity_id', value)}
                isValidCallback={(isValid) => this.setFieldValidity("entityId", isValid)}
                label="XPlan number" isHalf={true} value={this.props.client.entity_id} validations={[]}></Input>}
          </div>
          <div className="form-group">
            {this.state.client.identification_type === this.IDENTIFICATION_TYPES["Passport"] &&
              <div className="form-input form-input--large form-input--has-padding has-floating-label is-half">
                <label className="form-control">
                  <div className="form-control__label">
                    <span>Date of birth</span>
                  </div>
                  <div className="form-control__input">
                    <MuiPickersUtilsProvider utils={DateUtils}>
                      <DatePicker name="client[date_of_birth]" value={this.props.client.date_of_birth} onChange={(value) => this.onChange('date_of_birth', value)} format='yyyy-MM-dd' maxDate={new Date()} />
                    </MuiPickersUtilsProvider>
                  </div>
                </label>
              </div>
            }
          </div>
          {this.props.paraplannerWealthManagers &&
            <div className="form-group">
              <div className="form-input form-input--large form-input--has-padding has-floating-label is-half">
                <label className="form-control">
                  <div className="form-control__label">
                    <span>Wealth Manager</span>
                  </div>
                  <div className="form-control__input">
                    <Select
                      getOptionLabel={(option) => option['name']}
                      getOptionValue={(option) => option['id']}
                      maxHeight={100}
                      name="client[wealth_manager_id]"
                      styles={{
                        input: () => ({
                          height: '2rem'
                        })
                      }}
                      options={this.props.paraplannerWealthManagers}
                      noOptionsMessage={() => `You don't have any associated Wealth Managers, please contact your administrator for help setting your profile up with a wealth manager.`}
                      onChange={(option) => option && this.setFieldValidity("wealthManagerId", true)}
                    />
                  </div>
                </label>
              </div>
            </div>
          }
          {this.props.organizations &&
            <div className="form-group">
              <div className="form-input form-input--large form-input--has-padding has-floating-label is-half">
                <label className="form-control">
                  <div className="form-control__label">
                    <span>Organisation</span>
                  </div>
                  <div className="form-control__input">
                    <OrganizationSearchSelect
                      organizations={this.props.organizations}
                      name="client[organization_id]"
                      placeholder="Search for an organisation"
                      onChange={this.onOrgChange}
                    />
                  </div>
                </label>
              </div>
            </div>
          }
          {this.props.cohortsByOrg && this.state.selectedOrgId &&
            <div className="form-group">
              <div className="form-input form-input--large form-input--has-padding has-floating-label is-half">
                <label className="form-control">
                  <div className="form-control__label">
                    <span>Cohort</span>
                  </div>
                  <div className="form-control__input">
                    <Select
                      getOptionLabel={(option) => option['name']}
                      getOptionValue={(option) => option['id']}
                      name="client[cohort_id]"
                      isClearable={true}
                      value={this.state.selectedCohort}
                      placeholder="Select a cohort"
                      options={this.props.cohortsByOrg[this.state.selectedOrgId] || []}
                      noOptionsMessage={() => 'This organisation has no cohorts yet.'}
                      styles={{
                        input: () => ({
                          height: '2rem'
                        })
                      }}
                      onChange={this.onCohortChange}
                    />
                  </div>
                </label>
              </div>
            </div>
          }
        </fieldset>
        <fieldset>
          {!this.props.isProspect && this.props.canInvite &&
            <div className="form-input form-input--no-margin check_boxes">
              <Checkbox id="client_send_invite_input" name="send_invitation" value={this.state.sendInvitation} label="Send email invitation to client" onChange={this.onCheckboxChange}></Checkbox>
            </div>
          }
        </fieldset>


        <div className="form__actions form__actions--multiple form__actions--padding-half">
          <button disabled={!this.state.formValid} type="submit" className="button" onClick={this.submitGAEvent}>Save</button>
        </div>
      </SharedForm>
    )
  }
}
